/**
 * Convert board position (row, col) to chess notation (e.g., "A8", "B1")
 * Row 0 (top) = 8, Row 7 (bottom) = 1
 * Col 0 = A, Col 7 = H
 */
export function positionToChessNotation(row: number, col: number): string {
  const columns = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
  const rowNumber = 8 - row; // Row 0 = 8, Row 7 = 1
  const colLetter = columns[col];
  return `${colLetter}${rowNumber}`;
}

/**
 * Convert chess notation (e.g., "A8") to board position (row, col)
 */
export function chessNotationToPosition(notation: string): { row: number; col: number } | null {
  const match = notation.match(/^([A-H])([1-8])$/i);
  if (!match) return null;

  const colLetter = match[1].toUpperCase();
  const rowNumber = parseInt(match[2], 10);

  const columns = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
  const col = columns.indexOf(colLetter);
  const row = 8 - rowNumber; // Row number 8 = 0, Row number 1 = 7

  return { row, col };
}
